import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
/**SESIÓN */
import AuthContext from '../context/AuthContext';
import { loginUser } from '../api/auth';
/**COMPONENTES */
//import Titulo from '../../components/titulo';
import Input from '../components/form/input';
import Boton from '../components/form/boton';

const Login = () => {

    /**Estados inicio sesión*/
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [error, setError] = useState('');

    /**Sesión y navegación */
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    

    /**Actualizamos los estados con los valores introducidos en los inputs */
    const handleUserChange = (newValue) => {
        setUser(newValue);
    };

    const handlePasswordChange = (newValue) => {
        setPassword(newValue);
    };

    /**Inicio de sesión */
    const handleSubmit = async (e) => {

        e.preventDefault();

        // Cambiar el estado del botón de inicio de sesión a 'Iniciando sesión...'
        setIsLoggingIn(true);

        const userData = await loginUser(user, password);
        if (userData) {
          login(userData);
          navigate('/formulari');
        } else {
            setError('Usuari o contrasenya incorrectes.');
            setIsLoggingIn(false);
        }
    };

    return (
        <React.Fragment>
             <div id= "contenedor" className='w-full mx-auto bg-white flex md:justify-center md:p-12 sm:h-screen md:h-auto'>
                <div id="tarjeta" className="p-5 md:p-12 sm:w-full h-screen md:w-auto md:h-auto max-w-lg mx-auto mt-0 mb-0 rounded bg-background shadow-md">
                    <form onSubmit={handleSubmit} className='flex flex-col w-full md:w-auto font-inter'>
                        <div className='space-y-6'>
                            <h2 className='font-bold text-2xl'>Iniciar sessió</h2>
                            <p className='text-md mb-3'>Accedeix amb l’usuari i clau de la <span className='font-bold'>Intranet federativa</span> del teu club per iniciar sessió.</p>
                            <Input texto="Usuari" tipo="text" label="Usuari" value={user} onChange={handleUserChange}/>
                            <Input texto="password" tipo="password" label="Contrasenya" value={password} onChange={handlePasswordChange}/>
                            <Boton texto={isLoggingIn ? "Iniciant sessió..." : "Inicia sessió"} disabled={isLoggingIn}/>
                            { error && <p className='text-red-500 text-sm'>{error}</p>}
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Login;